export const formatNumber = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return num.toLocaleString('en-US');
};

export const extractNumbersFromString = (str: string): string => {
  const match = str.match(/\d+/);
  return match ? match[0] : str;
};

export const removeNumbersFromString = (str: string): string => {
  return str.replace(/\d+/g, '').trim();
};

export const formatPrice = (amount: string | number, decimals = 2): string => {
  const price = typeof amount === 'string' ? parseFloat(amount) : amount;
  return price.toFixed(decimals);
};

export const formatNumberWithSpaces = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return value.toString();

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
